'use es6'; //#region Imports

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, Component } from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import { connect } from 'react-redux';
import get from 'transmute/get';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import LegalConsentInputs from 'MeetingsLib/components/input/LegalConsentInputs';
import Branding from 'MeetingsBase/models/Branding';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import { getStagedLegalConsentResponses } from 'MeetingsLib/selectors/LegalConsentFormSelectors';
import { getCustomParams, getOffline as getOfflineSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus'; //#endregion Imports

const FormBodyCompact = styled.div.withConfig({
  displayName: "LegalConsentForm__FormBodyCompact",
  componentId: "f7x3g7-0"
})(["margin:0 32px;"]);
const FormBodyFull = styled(FormBodyCompact).withConfig({
  displayName: "LegalConsentForm__FormBodyFull",
  componentId: "f7x3g7-1"
})(["min-height:180px;max-height:80%;flex-shrink:1;overflow-y:scroll;overflow-x:hidden;"]);

class LegalConsentForm extends Component {
  constructor(...args) {
    super(...args);

    this.renderAccessibleMessage = () => {
      const {
        branding: {
          companyName
        },
        dateTime,
        userTimezone
      } = this.props;
      const selectedDate = I18n.moment(dateTime).tz(userTimezone).format('LLLL');

      let accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "accessible.privacyStatusNoCompany",
        options: {
          selectedDate
        }
      });

      if (companyName) {
        accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "accessible.privacyStatus",
          options: {
            domain: companyName,
            selectedDate
          }
        });
      }

      return accessibleMessage;
    };

    this.renderHeader = () => {
      return /*#__PURE__*/_jsxs(H4, {
        tabIndex: 1,
        className: "p-x-8 p-top-4 m-bottom-5",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "dataPrivacy"
        }), /*#__PURE__*/_jsx(HiddenAriaStatus, {
          role: "status",
          "aria-live": "polite",
          children: this.renderAccessibleMessage()
        })]
      });
    };

    this.renderLegalConsentInputs = () => {
      const {
        compact,
        legalConsentOptions,
        stagedLegalConsentResponses,
        setGivenConsent
      } = this.props;
      const FormBodyWrapper = compact ? FormBodyCompact : FormBodyFull;
      return /*#__PURE__*/_jsx(FormBodyWrapper, {
        className: `${compact ? 'm-bottom-4' : ''}`,
        children: /*#__PURE__*/_jsx(LegalConsentInputs, {
          legalConsentResponses: stagedLegalConsentResponses,
          legalConsentOptions: legalConsentOptions,
          setGivenConsent: setGivenConsent
        })
      });
    };
  }

  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderHeader(), this.renderLegalConsentInputs()]
    });
  }

}

LegalConsentForm.propTypes = {
  // passed
  compact: PropTypes.bool.isRequired,
  branding: PropTypes.instanceOf(Branding).isRequired,
  submittingMeeting: PropTypes.bool,
  dateTime: PropTypes.number.isRequired,
  // loaded
  legalConsentOptions: PropTypes.instanceOf(LegalConsentOptions).isRequired,
  stagedLegalConsentResponses: PropTypes.instanceOf(List),
  offline: PropTypes.bool,
  userTimezone: PropTypes.string.isRequired,
  // loaded dispatch
  setGivenConsent: PropTypes.func.isRequired
};
export default connect(state => ({
  legalConsentOptions: get('legalConsentOptions', getCustomParams(state)),
  stagedLegalConsentResponses: getStagedLegalConsentResponses(state),
  offline: getOfflineSelector(state),
  userTimezone: state.userTimezone
}), Object.assign({}, FormActions))(LegalConsentForm);